/* eslint-disable */
// @ts-nocheck
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unknown-property */
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/no-unresolved */
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars, react/jsx-newline, react/jsx-no-bind, no-else-return */
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps, @typescript-eslint/no-use-before-define, no-lonely-if, no-nested-ternary, import/no-extraneous-dependencies */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Modal, Descriptions, Typography, Row, Col, Table, Tag, Button, Divider, Card, message } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useIntl } from 'react-intl';
import './SettlementViewModal.css';
import { generateSettlementPDF } from '../../utils/pdfGenerator';

const { Title, Text } = Typography;

const statusColors = {
  Draft: 'default',
  Confirmed: 'processing',
  Cleared: 'success',
  Reversed: 'error'
};

// Inline styles matching ReviewSettlement
const styles = {
  journalEntryContainer: {
    width: '100%',
    margin: '16px 0',
    border: '1px solid #f0f0f0',
    borderRadius: '4px',
    overflow: 'hidden',
    textAlign: 'center'
  },
  journalEntryHeader: {
    background: '#fafafa',
    padding: '12px 16px',
    borderBottom: '1px solid #f0f0f0',
    fontWeight: 500,
    fontSize: '12px'
  },
  journalEntryTable: {
    width: '100%',
    fontSize: '14px',
    textAlign: 'center'
  },
  journalEntryRow: {
    display: 'flex',
    borderBottom: '1px solid #f0f0f0',
    textAlign: 'center'
  },
  journalEntryCell: (flex = 1, align = 'left') => ({
    padding: '12px 16px',
    flex: flex,
    textAlign: align,
    borderRight: '1px solid #f0f0f0',
    fontSize: '12px',
    ':last-child': {
      borderRight: 'none'
    }
  }),
  journalEntryFooter: {
    background: '#fafafa',
    padding: '12px 16px',
  }
};

const SettlementViewModal = ({ visible, onClose, settlement }) => {
  const intl = useIntl();

  // Helper function to format financial values
  const formatAmount5 = (value) => {
    return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 5, maximumFractionDigits: 5 });
  };
  const formatAmount2 = (value) => {
    return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // Helper function to translate status values
  const getTranslatedStatus = (status) => {
    const statusTranslations = {
      'Draft': intl.formatMessage({ id: 'settlement_StatusDraft' }),
      'Confirmed': intl.formatMessage({ id: 'settlement_StatusConfirmed' }),
      'Cleared': intl.formatMessage({ id: 'settlement_StatusCleared' }),
      'Reversed': intl.formatMessage({ id: 'settlement_StatusReversed' })
    };
    return statusTranslations[status] || status;
  };

  if (!settlement) return null;

  const fmt = (d) => {
    if (!d) return '—';
    try {
      return moment(d).format('DD-MM-YYYY');
    } catch (error) {
      console.warn('Date formatting error in SettlementViewModal:', error, d);
      return d;
    }
  };
  const amount = Number(settlement.amount || 0);
  // Use summed values if available (from ReviewSettlement logic), otherwise use absolute values
  const fees = Math.abs(Number(settlement.summed_fees || settlement.fees_amount || 0));
  const vat = Math.abs(Number(settlement.summed_vat || settlement.tax_amount || 0));
  const currency = settlement.currency || 'EGP';
  // RTL support for Arabic
  const currentLanguageCode = localStorage.getItem('EASY_MOBILITY_LANGUAGE') || 'en-us';
  const isArabic = currentLanguageCode === 'ar-eg';

  const getSenderBankName = () => {
    return settlement.sender_bank_name || intl.formatMessage({ id: 'settlement_SenderBankNotSelected' });
  };

  const getBeneficiaryBankName = () => {
    return settlement.beneficiary_bank_name || intl.formatMessage({ id: 'settlement_BeneficiaryBankNotSelected' });
  };

  const getSenderBankAccountDisplay = () => {
    if (!settlement.sender_bank_account_number) return intl.formatMessage({ id: 'settlement_SenderAccountNotSelected' });
    const iban = settlement.sender_bank_iban ? ` (IBAN: ${settlement.sender_bank_iban})` : '';
    return `${settlement.sender_bank_account_number}${iban}`;
  };

  const getBeneficiaryBankAccountDisplay = () => {
    if (!settlement.beneficiary_bank_account_number) return intl.formatMessage({ id: 'settlement_BeneficiaryAccountNotSelected' });
    const iban = settlement.beneficiary_bank_iban ? ` (IBAN: ${settlement.beneficiary_bank_iban})` : '';
    return `${settlement.beneficiary_bank_account_number}${iban}`;
  };

  // Map common account names (with or without codes) to translated versions
  const getAccountName = (accountName) => {
    const accountMappings = {
      'Unsettled Dues (11200)': intl.formatMessage({ id: 'settlement_UnsettledDues' }),
      'Bank Account (10100)': intl.formatMessage({ id: 'settlement_BankAccountAssetName' }),
      'Commission Income (40100)': intl.formatMessage({ id: 'settlement_CommissionIncomeAccount' }),
      'VAT Payable (20300)': intl.formatMessage({ id: 'settlement_VATPayableAccount' }),
      'Operating Account (10100)': intl.formatMessage({ id: 'settlement_OperatingAccountName' }),
      'Fare Revenue (40100)': intl.formatMessage({ id: 'settlement_FareRevenueAccount' }),
      'Commission Expense (50100)': intl.formatMessage({ id: 'settlement_CommissionExpenseAccount' }),
      'VAT Receivable (10200)': intl.formatMessage({ id: 'settlement_VATReceivableAccount' }),
      // Without codes
      'Unsettled Dues': intl.formatMessage({ id: 'settlement_UnsettledDues' }),
      'Bank Account': intl.formatMessage({ id: 'settlement_BankAccountAssetName' }),
      'Commission Income': intl.formatMessage({ id: 'settlement_CommissionIncomeAccount' }),
      'VAT Payable': intl.formatMessage({ id: 'settlement_VATPayableAccount' }),
      'Operating Account': intl.formatMessage({ id: 'settlement_OperatingAccountName' }),
      'Fare Revenue': intl.formatMessage({ id: 'settlement_FareRevenueAccount' }),
      'Commission Expense': intl.formatMessage({ id: 'settlement_CommissionExpenseAccount' }),
      'VAT Receivable': intl.formatMessage({ id: 'settlement_VATReceivableAccount' })
    };
    return accountMappings[accountName] || accountName;
  };

  // ERP journal suggestions (exact same logic as ReviewSettlement)
  const totalDebit = Math.abs(amount) + fees + vat;

  // Sender suggested journal entries (our company) - matching ReviewSettlement exactly
  const journalEntries = [
    {
      account: getAccountName('Unsettled Dues (11200)'),
      debit: totalDebit,
      credit: null,
      description: intl.formatMessage({ id: 'settlement_ClearUnsettledDuesLiability' })
    },
    {
      account: getAccountName('Bank Account (10100)'),
      debit: null,
      credit: Math.abs(amount),
      description: intl.formatMessage({ id: 'settlement_NetCashTransferredToPTO' })
    },
    {
      account: getAccountName('VAT Payable (20300)'),
      debit: null,
      credit: vat,
      description: intl.formatMessage({ id: 'settlement_VATOnFeesTotal' })
    },
    {
      account: getAccountName('Commission Income (40100)'),
      debit: null,
      credit: fees,
      description: intl.formatMessage({ id: 'settlement_TotalFeesEarnedSummed' })
    }
  ];

  // Beneficiary suggested journal entries (PTO) - matching ReviewSettlement exactly
  const beneficiaryJournalEntries = [
    {
      account: getAccountName('Operating Account (10100)'),
      debit: Math.abs(amount),
      credit: null,
      description: intl.formatMessage({ id: 'settlement_NetCashReceivedFromSender' })
    },
    {
      account: getAccountName('Commission Expense (50100)'),
      debit: fees,
      credit: null,
      description: intl.formatMessage({ id: 'settlement_CommissionExpenseTotal' })
    },
    {
      account: getAccountName('VAT Receivable (10200)'),
      debit: vat,
      credit: null,
      description: intl.formatMessage({ id: 'settlement_VATOnCommissionTotal' })
    },
    {
      account: getAccountName('Fare Revenue (40100)'),
      debit: null,
      credit: totalDebit,
      description: intl.formatMessage({ id: 'settlement_RecognizeFareRevenueAndFeesTotal' })
    }
  ];

  const senderTotalDebit = journalEntries.reduce((sum, entry) => sum + (entry.debit || 0), 0);
  const senderTotalCredit = journalEntries.reduce((sum, entry) => sum + (entry.credit || 0), 0);

  const benTotalDebit = beneficiaryJournalEntries.reduce((sum, entry) => sum + (entry.debit || 0), 0);
  const benTotalCredit = beneficiaryJournalEntries.reduce((sum, entry) => sum + (entry.credit || 0), 0);

  return (
    <Modal
      title={intl.formatMessage({ id: 'settlement_SettlementDetails' })}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      className="settlement-view-modal"
      destroyOnClose
    >
      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <Title level={4} style={{ margin: 0 }}>
            <CheckCircleOutlined /> {settlement.id}
          </Title>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <Text>
              {intl.formatMessage({ id: 'settlement_Status' })}: <Tag color={statusColors[settlement.status] || 'default'}>{getTranslatedStatus(settlement.status)}</Tag>
            </Text>
            {settlement.status !== 'Draft' && (
              <Button
                onClick={async () => {
                  try {
                    const pdfPayload = {
                      id: settlement.id,
                      sender: settlement.sender_name || 'Sender',
                      beneficiary: settlement.beneficiary_name || 'PTO',
                      fromDate: fmt(settlement.settlement_from_date),
                      toDate: fmt(settlement.settlement_till_date),
                      currency,
                      amount: Math.abs(amount),
                      status: settlement.status || 'Draft',
                      senderBank: getSenderBankAccountDisplay() || '',
                      beneficiaryBank: getBeneficiaryBankAccountDisplay() || '',
                      senderBankName: settlement.sender_bank_name || '',
                      beneficiaryBankName: settlement.beneficiary_bank_name || '',
                      bank_ref_no: settlement.bank_ref_no || '',
                      bank_description: settlement.bank_description || '',
                      bank_transfer_date: settlement.bank_transfer_date,
                      notes: settlement.notes || '',
                      // Add missing fields from database
                      reversal_reason: settlement.reversal_reason || '',
                      reversed_at: settlement.reversed_at || '',
                      reversed_by: settlement.reversed_by || '',
                      created_at: settlement.created_at || '',
                      senderJournalEntries: journalEntries,
                      beneficiaryJournalEntries: beneficiaryJournalEntries
                    };

                    // Store data in sessionStorage for the new tab
                    sessionStorage.setItem('settlementPDFData', JSON.stringify(pdfPayload));

                    // Open PDF preview in new tab
                    const newTab = window.open('/settlements/settlementTransactions/pdf-preview', '_blank');
                    if (!newTab) {
                      message.error(intl.formatMessage({ id: 'settlement_PleaseAllowPopups' }));
                    } else {
                      message.success(intl.formatMessage({ id: 'settlement_PDFPreviewOpened' }));
                    }
                  } catch (err) {
                    console.error('Error opening PDF preview:', err);
                    message.error(intl.formatMessage({ id: 'settlement_FailedToOpenPDFPreview' }));
                  }
                }}
              >
                {intl.formatMessage({ id: 'settlement_PrintSettlement' })}
              </Button>
            )}
          </div>
        </div>
        {/* Reversal Information Section (only for Reversed status) */}
        {settlement.status === 'Reversed' && (settlement.reversal_reason || settlement.reversed_at) && (
          <Row gutter={[24, 16]} style={{ marginTop: 12 }}>
            <Col xs={24}>
              <Descriptions column={2} bordered size="small">
                {settlement.reversal_reason && (
                  <Descriptions.Item label={intl.formatMessage({ id: 'settlement_ReversalReason' })}>
                    <Text>{settlement.reversal_reason}</Text>
                  </Descriptions.Item>
                )}
                {settlement.reversed_at && (
                  <Descriptions.Item label={intl.formatMessage({ id: 'settlement_ReversedAt' })}>
                    <Text>{fmt(settlement.reversed_at)}</Text>
                  </Descriptions.Item>
                )}

              </Descriptions>
            </Col>
          </Row>
        )}
        {/* Section 1: Period at top */}
        <Row gutter={[24, 16]} style={{ marginTop: 8 }}>
          <Col xs={24}>
            <Descriptions title={intl.formatMessage({ id: 'settlement_PeriodLabel' })} column={2} bordered size="small">
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_From' })}>
                <Text>{fmt(settlement.settlement_from_date)}</Text>
              </Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_To' })}>
                <Text>{fmt(settlement.settlement_till_date)}</Text>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>

        {/* Section 2: Parties & Banks */}
        <Row gutter={[24, 16]} style={{ marginTop: 12 }}>
          <Col xs={24} md={12}>
            <Descriptions title={intl.formatMessage({ id: 'settlement_SenderOurCompany' })} column={1} bordered size="small">
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Organisation' })}>{settlement.sender_name || intl.formatMessage({ id: 'settlement_SenderNotSelected' })}</Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Bank' })}>{getSenderBankName()}</Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_BankAccount' })}>{getSenderBankAccountDisplay()}</Descriptions.Item>
            </Descriptions>
          </Col>

          <Col xs={24} md={12}>
            <Descriptions title={intl.formatMessage({ id: 'settlement_BeneficiaryPTO' })} column={1} bordered size="small">
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Organisation' })}>{settlement.beneficiary_name || intl.formatMessage({ id: 'settlement_BeneficiaryNotSelected' })}</Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Bank' })}>{getBeneficiaryBankName()}</Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_BankAccount' })}>{getBeneficiaryBankAccountDisplay()}</Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>

        {/* Amount & Currency section */}
        <Row gutter={[24, 16]} style={{ marginTop: 12 }}>
          <Col xs={24}>
            <Descriptions title={intl.formatMessage({ id: 'settlement_AmountCurrency' })} column={2} bordered size="small">
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Amount' })}>
                <Text>{formatAmount2(amount)}</Text>
              </Descriptions.Item>
              <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Currency' })}>
                <Text>{currency}</Text>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>



        {/* Section 3: Suggested ERP Journal Entries */}
        <div style={{ marginTop: 24 }}>
          {/* Sender Journal Entry */}
          <div style={styles.journalEntryContainer}>
            <div style={{ ...styles.journalEntryHeader, textAlign: 'center' }}>{intl.formatMessage({ id: 'settlement_SuggestedERPJournalEntrySenderTitle' })}</div>
            <div style={styles.journalEntryTable}>
              <div style={{ ...styles.journalEntryRow, background: '#fafafa', fontWeight: 500 }}>
                <div style={styles.journalEntryCell(3)}>{intl.formatMessage({ id: 'settlement_Account' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>{intl.formatMessage({ id: 'settlement_Debit' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>{intl.formatMessage({ id: 'settlement_Credit' })}</div>
                <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}>{intl.formatMessage({ id: 'settlement_Description' })}</div>
              </div>
              {journalEntries.map((entry, index) => (
                <div key={index} style={styles.journalEntryRow}>
                  <div style={styles.journalEntryCell(3)}>{entry.account}</div>
                  <div style={styles.journalEntryCell(1, 'right')}>
                    {entry.debit ? `${formatAmount5(entry.debit)} EGP` : '-'}
                  </div>
                  <div style={styles.journalEntryCell(1, 'right')}>
                    {entry.credit ? `${formatAmount5(entry.credit)} EGP` : '-'}
                  </div>
                  <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}>{entry.description}</div>
                </div>
              ))}
              <div style={{ ...styles.journalEntryRow, background: '#fafafa', fontWeight: 500 }}>
                <div style={styles.journalEntryCell(3)}>{intl.formatMessage({ id: 'settlement_Total' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>
                  {formatAmount5(senderTotalDebit)} EGP
                </div>
                <div style={styles.journalEntryCell(1, 'right')}>
                  {formatAmount5(senderTotalCredit)} EGP
                </div>
                <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}></div>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 24 }} />

          {/* Beneficiary Journal Entry */}
          <div style={styles.journalEntryContainer}>
            <div style={{ ...styles.journalEntryHeader, textAlign: 'center' }}>{intl.formatMessage({ id: 'settlement_SuggestedERPJournalEntryBeneficiaryTitle' })}</div>
            <div style={styles.journalEntryTable}>
              <div style={{ ...styles.journalEntryRow, background: '#fafafa', fontWeight: 500 }}>
                <div style={styles.journalEntryCell(3)}>{intl.formatMessage({ id: 'settlement_Account' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>{intl.formatMessage({ id: 'settlement_Debit' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>{intl.formatMessage({ id: 'settlement_Credit' })}</div>
                <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}>{intl.formatMessage({ id: 'settlement_Description' })}</div>
              </div>
              {beneficiaryJournalEntries.map((entry, index) => (
                <div key={index} style={styles.journalEntryRow}>
                  <div style={styles.journalEntryCell(3)}>{entry.account}</div>
                  <div style={styles.journalEntryCell(1, 'right')}>
                    {entry.debit ? `${formatAmount5(entry.debit)} EGP` : '-'}
                  </div>
                  <div style={styles.journalEntryCell(1, 'right')}>
                    {entry.credit ? `${formatAmount5(entry.credit)} EGP` : '-'}
                  </div>
                  <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}>{entry.description}</div>
                </div>
              ))}
              <div style={{ ...styles.journalEntryRow, background: '#fafafa', fontWeight: 500 }}>
                <div style={styles.journalEntryCell(3)}>{intl.formatMessage({ id: 'settlement_Total' })}</div>
                <div style={styles.journalEntryCell(1, 'right')}>
                  {formatAmount5(benTotalDebit)} EGP
                </div>
                <div style={styles.journalEntryCell(1, 'right')}>
                  {formatAmount5(benTotalCredit)} EGP
                </div>
                <div style={{ ...styles.journalEntryCell(2), borderRight: 'none' }}></div>
              </div>
            </div>
          </div>
        </div>
        {/* Additional Settlement Info */}
        {(settlement.bank_ref_no || settlement.bank_transfer_date || settlement.bank_description) && (
          <Row gutter={[24, 16]} style={{ marginTop: 12 }}>
            <Col xs={24}>
              <Descriptions title={intl.formatMessage({ id: 'settlement_BankTransferDetails' })} column={1} bordered size="small">
                {settlement.bank_ref_no && (
                  <Descriptions.Item label={intl.formatMessage({ id: 'settlement_ACHReference' })}>{settlement.bank_ref_no}</Descriptions.Item>
                )}
                {settlement.bank_transfer_date && (
                  <Descriptions.Item label={intl.formatMessage({ id: 'settlement_TransferDate' })}>{fmt(settlement.bank_transfer_date)}</Descriptions.Item>
                )}
                {settlement.bank_description && (
                  <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Description' })}>{settlement.bank_description}</Descriptions.Item>
                )}
              </Descriptions>
            </Col>
          </Row>
        )}
        {/* Bank Transfer Notes */}
        <Row gutter={[24, 16]} style={{ marginTop: 24 }}>
          <Col xs={24}>
            <Card size="small" title={intl.formatMessage({ id: 'settlement_BankTransferNotes' })}>
              <Text>{settlement.notes || intl.formatMessage({ id: 'settlement_NoAdditionalNotes' })}</Text>
            </Card>
          </Col>
        </Row>
      </Card>
    </Modal>
  );
};

export default SettlementViewModal;
